module.exports = __webpack_public_path__ + "img/step1-c.6a99810a.png";